
import Vue from 'vue';
import Angry from './angry.vue';
import Awesome from './awesome.vue';
import Help from './help.vue';
import Whatever from './whatever.vue';
import Laugh from './laugh.vue';
import EventBus from '../../helpers/eventBus';
import { UserModel } from '@descomplica/dex-models';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { TrackLessonReactedType } from '@/helpers/analytics/types';

interface ReactionType {
  component: any;
  name: string;
  trackingName: string;
}

export default Vue.extend({
  props: {
    user: {
      type: Object as Vue.PropType<UserModel>,
      required: true,
    },
    getTrackingData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      reactions: [
        {
          component: Angry,
          name: 'Angry',
          trackingName: 'Raiva',
        },
        {
          component: Awesome,
          name: 'Awesome',
          trackingName: 'Demais',
        },
        {
          component: Help,
          name: 'Help',
          trackingName: 'Socorro',
        },
        {
          component: Whatever,
          name: 'Whatever',
          trackingName: 'Tédio',
        },
        {
          component: Laugh,
          name: 'Laugh',
          trackingName: 'HaHaHa',
        },
      ],
    };
  },
  methods: {
    clickHandler(reaction: ReactionType): void {
      const trackingData = this.getTrackingData ? this.getTrackingData() : {};

      const eventData: TrackLessonReactedType = {
        reaction: reaction.name,
        reaction_name: reaction.trackingName,
        ...trackingData,
      };

      EventBus.publishEvent(this.user.id.toString(), 'Lesson Reacted', eventData);
      Analytics.trackEvent(EVENT_LABELS.lessonReacted, eventData);
    },
  },
});
